import React from 'react';
import { ClientHomeIcon } from 'components/Icons';
import { AutoCompleteInput } from './AutoCompleteInput';
import { Input } from 'components/ui/input';

export const AddressInformation = ({
  methods,
  placeAutocomplete,
  selectedPlace,
  setSelectedPlace,
  setIsDropdownActive,
  setters,
  countryState,
  countryCity,
  countryZipcode,
  aptOrSuite,
}) => {
  return (
    <div className="flex items-center flex-wrap mt-[24px] gap-[8px] md:gap-[18px]">
      <div className="flex flex-wrap gap-[20px] w-full">
        <AutoCompleteInput
          searchType="address"
          onPlaceSelect={setSelectedPlace}
          placeAutocomplete={placeAutocomplete}
          setPlaceAutocomplete={setters.setPlaceAutocomplete}
          setCountryState={setters.setCountryState}
          setCountryCity={setters.setCountryCity}
          setCountryZipcode={setters.setCountryZipcode}
          selectedPlace={selectedPlace}
          setSelectedPlace={setSelectedPlace}
          setAptOrSuite={setters.setAptOrSuite}
          onDropdownStateChange={setIsDropdownActive}
          setManualAddress={setters.setManualAddress}
        />

        <Input
          name="suiteOrApt"
          type="text"
          height="56px"
          className="w-full md:w-[198px]"
          icon={<ClientHomeIcon className="!text-transparent" />}
          label="Suite/APT"
          onChange={(e) => {
            methods.setValue("suiteOrApt", e.target.value);
            setters.setAptOrSuite(e.target.value);
          }}
          value={aptOrSuite ?? ""}
        />

        <Input
          name="state"
          type="text"
          height="56px"
          className="w-full md:w-[198px]"
          icon={<ClientHomeIcon className="!text-transparent" />}
          label="State"
          onChange={(e) => {
            methods.setValue("state", e.target.value);
            setters.setCountryState(e.target.value);
          }}
          value={countryState}
        />

        <Input
          icon={<ClientHomeIcon className="!text-transparent" />}
          className="w-full md:w-[198px]"
          type="text"
          name="zipCode"
          label="Zip code"
          onChange={(e) => {
            methods.setValue("zipCode", e.target.value);
            setters.setCountryZipcode(e.target.value);
          }}
          value={countryZipcode}
        />

        <Input
          type="text"
          name="city"
          className="w-full md:w-[198px]"
          icon={<ClientHomeIcon className="!text-transparent" />}
          onChange={(e) => {
            methods.setValue("city", e.target.value);
            setters.setCountryCity(e.target.value);
          }}
          label="City"
          value={countryCity}
        />

        <Input
          name="country"
          type="text"
          height="56px"
          className="w-full md:w-[198px]"
          icon={<ClientHomeIcon className="!text-transparent" />}
          label="Country"
          readOnly
          disabled
          value="United States"
        />
      </div>
    </div>
  );
};
